<script setup>
import { onUpdated, onMounted, ref, defineEmits, defineProps } from "vue"
import { useRouter } from "vue-router"
import { KNOLIA } from "../knolia"
import { Gems } from "../gems"

const emits = defineEmits(['open-profile'])
const props = defineProps({
  isMobile: {
    type: Boolean,
    default: false
  },
  userStore: {
    type: Object,
    default: Object
  }
})
const defaultImage = ref(require('@/images/default.png'))
const isOffCanvas = ref(false)

let router = useRouter()

function ToProfile(user) {
  KNOLIA.SetRequestedUserId(user.id)
  emits('open-profile')
}

function IsActualRoute(view){
  if(router.currentRoute.value.path === view || router.currentRoute.value.meta.principalNode === view)
    return 'active'
  
  return ''
}

function GoToUsers() {
  window.dispatchEvent(new Event('users-menu-navigation'))

  if (router.currentRoute.value.path === '/users') {
    return
  }

  router.push('/users')
}

onMounted(async () => {
  isOffCanvas.value = props.isMobile ? 'offcanvas' : ''
});

onUpdated(async () => {
  const photo = document.getElementById('section-menu')
  if(photo)
    Gems.Tooltip(photo, 'Meu perfil', 'tooltip')
})

</script>

<template>
  <div class="menu-container">

    <div class="logo-box"></div>
    <div class="entity-name knolia-gradient-default">{{userStore.Core.entity}}</div>
    
    <div class="div-menu-logged" v-if="Object.keys(userStore.User).length > 0">
      <div style="display: flex; position: relative">
        <div class="section-menu" id="section-menu">
          <img id="div-logo" class="div-logo" @click="ToProfile(userStore.User)" :src="userStore.User.src ?? defaultImage" @error="$event.target.src = defaultImage">
        </div>
      </div>
      <p class="div-logged knolia-gradient-default-hover" @click="ToProfile(userStore.User)">{{ userStore.User.professional_name }}</p>
      <p class="div-job">{{ userStore.User.user_job }}</p>
    </div>

    <div class="menu-list" v-show="Object.keys(userStore.User).length > 0">
      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/admin')" v-if="userStore.User?.permissions?.is_admin">
        <span class="menu-text knolia-gradient-default-hover" @click="router.push('/admin')">Admin</span>
      </div>

      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/my-knolia')">
        <div class="menu-text knolia-gradient-default-hover" @click="router.push('/my-knolia')">
          <span>Meu Knolia</span>

          <div class="div-counter" v-if="props.userStore.CountMessages.rating_skills_message_count > 0" @mouseenter="Gems.Tooltip($event.target, 'Mensagens não vistas', 'tooltip')">
            <i class="fa-solid fa-envelope"></i>
            <div class="counter-container">
              <p class="div-count">{{ props.userStore.CountMessages.rating_skills_message_count }}</p>
            </div>
          </div>
        </div>
      </div>

      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/management')">
        <span class="menu-text knolia-gradient-default-hover" @click="router.push('/management')" >Explorar</span>
      </div>

      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/users')">
        <span class="menu-text knolia-gradient-default-hover" @click="GoToUsers">Utilizadores</span>
      </div>

      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/validate-skills')" v-if="userStore.User?.permissions?.is_validator">
        <div class="menu-text knolia-gradient-default-hover" @click="router.push('/validate-skills')">
          <span>Pedidos</span>
          <div class="div-counter" v-if="props.userStore.CountValidations.total > 0" @mouseenter="Gems.Tooltip($event.target, 'Pedidos que tem por publicar', 'tooltip')">
            <i class="fas fa-bell icon-bell"></i>
            <div class="counter-container">
              <p class="div-count">{{ props.userStore.CountValidations.total }}</p>
            </div>
          </div>
          
          <div class="div-counter" v-if="props.userStore.CountMessages.validation_total_messages_count > 0" @mouseenter="Gems.Tooltip($event.target, 'Mensagens não vistas', 'tooltip')">
            <i class="fa-solid fa-envelope"></i>
            <div class="counter-container">
              <p class="div-count">{{ props.userStore.CountMessages.validation_total_messages_count }}</p>
            </div>
          </div>
        </div>
      </div>

      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/help')">
        <span class="menu-text knolia-gradient-default-hover" @click="router.push('/help')">Ajuda</span>
      </div>
      
      <div :data-bs-dismiss="isOffCanvas" :class="IsActualRoute('/privacy')">
        <span class="menu-text knolia-gradient-default-hover" @click="router.push('/privacy')">Privacidade</span>
      </div>

      <div :data-bs-dismiss="isOffCanvas">
        <span class="menu-text knolia-gradient-default-hover" @click="KNOLIA.LogOut()">Sair</span>
      </div>
    </div>
    
    <div id="entity-logo" class="div-entity-logo" :style="`background-image: url(${userStore.Core.logo});`">
      <img id="img-entity-logo" :src="userStore.Core.logo"/>
    </div>
  </div>
</template>

<style>
  .active,
  .active .div-counter {
    background: linear-gradient(145deg, var(--knolia-blue-1), var(--knolia-blue-5));
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content !important;
  }

  .active .div-count {
    background: white;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    width: -moz-fit-content !important;
    width: fit-content !important;
  }

</style>

<style scoped>

  .active .knolia-gradient-default-hover:hover .icon-bell,
  .active .knolia-gradient-default-hover:hover .fa-envelope,
  .active .knolia-gradient-default-hover:hover {
    background: unset !important;
  }
  
  .knolia-gradient-default-hover:hover .icon-bell,
  .knolia-gradient-default-hover:hover .fa-envelope {
    background: linear-gradient(145deg, var(--knolia-blue-1), var(--knolia-blue-5));
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content !important;
  }

  .knolia-gradient-default-hover:hover .div-count {
    background: white;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content !important;
  }

  .menu-container {
    background-color: #000;
    color: #fff;
    width: 100%;
    min-height: 100vh;
    width: 230px;
  }

  .menu-list {
    padding: 8px 0 0 10px;
    -webkit-tap-highlight-color: transparent;
    width: 230px;
  }

  .menu-list div {
    height: 42px;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 2px;
    display: flex;
  }

  .menu-text {
    align-self: center;
    align-items: center;
    margin-left: 11px; 
    cursor: pointer;
  }

  .logo-box {
    background-image: url("../images/logo.png");
    height: 120px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin: 4% 6% 0% 4%;
  }

  .entity-name {
    text-transform: uppercase;
    color: transparent;
    margin: -15px 0 5px 20px;
    font-size: .9rem;
    font-weight: 600;
  }

  .logout {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .div-menu-text-container {
    display: flex;
    align-items: center;
  }

  .section-menu {
    width: 60px;
    height: 60px;
    margin: 0 auto 10px;
  }

  .div-logo {
    height: 100%;
    width: 100%;
    cursor: pointer;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    transition: 0.5s ease;
    box-shadow: 0 3px 4px rgb(0 0 0 / 10%), 0 4px 10px rgb(0 0 0 / 20%);
    object-fit: cover;
  }

  .div-logged {
    text-align: center;
    font-weight: 600;
    font-size: 11pt;
    margin-top: 3px;
    cursor: pointer;
  }

  .div-logged:hover {
    text-align: center;
    margin-top: 3px;
    margin-left: auto;
    margin-right: auto;
  }

  .div-job {
    font-size: 10pt;
    font-weight: 150;
    margin-top: 3px;
    margin-bottom: 15px;
    text-align: center;
    color: #e4e4e4;
  }

  .div-entity-logo {
    width: 100%;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    max-width: calc(100% - 20px);
    margin: auto;
  }

  .div-entity-logo>img {
    width: 100%;
    visibility: hidden;
    max-height: 200px;
  }

  .div-validation {
    margin-left: 11px;
    display: flex;
  }

  .counter-container {
    position: absolute;
    top: 9px;
    left: 9px;
    width: 14px !important;
    height: 14px !important;
    border-radius: 50% !important;
    background-color: red;
    color: white;
    font-size: 0.6em;
    text-align: center;
  }

  .icon-bell {
    font-size: 12pt;
  }

  .div-counter {
    display: none;
    position: relative;
    margin-left: 10px;
    align-items: center;
    top: -3px;
  }

  .div-count {
    padding: 0;
    font-size: 7pt;
    margin: 0 auto;
  }

  .knolia-gradient-default-hover:hover,
  .knolia-gradient-default-hover:hover .icon-bell,
  .knolia-gradient-default-hover:hover .fa-envelope {
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 700px) {
    .logo-box {
      margin: none;
    }
  }

</style>